import { NotificationQueueItem } from '@wix/da-shared-react/pkg/Notifications';
import { NotificationType } from '../../types/notifications';
import DeviationSubmitNotification from '../DeviationSubmitNotification';
import DeviationMergeNotification from '../DeviationMergeNotification';
import DeviationScheduleNotification from '../DeviationScheduleNotification';
import BookmarkAddedNotification from '../BookmarkAddedNotification/BookmarkAddedNotification';
import SaveToDraftsNotification from '../SaveToDraftsNotification';

export const submitNotificationRenderer = (
  notification: NotificationQueueItem,
  removeNotification
) => {
  switch (notification.type) {
    case NotificationType.DEVIATION_SUBMIT:
      return (
        <DeviationSubmitNotification
          id={notification.id}
          queueName={notification.queueName}
          type={notification.type}
          {...notification.params}
        />
      );
    case NotificationType.DEVIATION_MERGE:
      return (
        <DeviationMergeNotification
          id={notification.id}
          queueName={notification.queueName}
          type={notification.type}
          {...notification.params}
        />
      );
    case NotificationType.DEVIATION_SCHEDULE:
      return (
        <DeviationScheduleNotification
          id={notification.id}
          queueName={notification.queueName}
          type={notification.type}
          {...notification.params}
        />
      );
    case NotificationType.BOOKMARK_ADDED:
      return (
        <BookmarkAddedNotification
          id={notification.id}
          queueName={notification.queueName}
          type={notification.type}
          {...notification.params}
        />
      );
    case NotificationType.SAVE_TO_DRAFTS:
      return (
        <SaveToDraftsNotification
          id={notification.id}
          queueName={notification.queueName}
          {...notification.params}
        />
      );
    default:
      return null;
  }
};
